import svc = require("./Service");
import axios from 'axios';

export interface IResolvedUser {
    Type: string;
    FirstName: string;
    LastName: string;
    DisplayName: string;
    LookupKey: string;
    Email: string;
    IsValid: boolean;
    Realm?: string;
    UserPrincipalName: string;
    IsDistributionGroup: boolean;
    EmployeeTitle: string;
}


export class Service {
    private serviceUrl: string;
    private static lookupCache: { [key: string]: Promise<IResolvedUser> } = {};

    constructor(serviceUrl?: string) {
        if (!serviceUrl) {
            serviceUrl = svc.globalPageData().urls.resolveNetId;
        }
        this.serviceUrl = serviceUrl;
    }
    private generateKey(username: string, realm?: string) {
        return `${username}_${realm}`;
    }

    lookupUsername(username: string, realm?: string): Promise<IResolvedUser> {
        const key = this.generateKey(username, realm);

        const cached = Service.lookupCache[key];
        if (cached) {
            return cached;
        }

        const params: any = { netIdOrGroup: username };
        if (realm) {
            params.realm = realm;
        }

        let p = new Promise<IResolvedUser>((resolve, reject) => {
            axios.get(this.serviceUrl, { params: params }).then((response) => resolve(response?.data?.Data), error => reject(error));
        });

        Service.lookupCache[key] = p;
        return p;
    }
}